export default function Home(style) {
  return <div style={{ gridArea: "Routes" }}>Home</div>;
}
